import { Session } from '@ais-ui/auth';

interface JobTemplateResult {
  is_delta: boolean;
  records: ReportTemplate[];
}

export interface Job {
  creationdate: Date;
  creationdateStr: string;
  failureReason: string;
  jobWeight: string;
  name: string;
  owner: string;
  percentComplete: number;
  status: string;
  uuid: string;
}

interface Schedule {
  endTime: Date;
  interval: string;
  intervalStart: number;
  isActive: boolean;
  isShared: boolean;
  name: string;
  templateUid: string;
  uid: string;
  userName: string;
}

export interface ReportTemplate {
  groups: string[];
  isEditable: boolean;
  isScheduled: boolean;
  isUpdateable: boolean;
  jobs: Job[];
  schedule?: Schedule;
  tplName: string;
  tplOwner: string;
  tplUuid: string;
  tplnewestcreationdate: number;
  tplneweststatus: string;
  type: string;
}

type Coordinate = string; // Assuming coordinates are strings, adjust if needed

export interface Info {
  Area: string;
  'Coordinates (1)': Coordinate;
  'Coordinates (2)': Coordinate;
  'Coordinates (3)': Coordinate;
  'Coordinates (4)': Coordinate;
  Created: Date;
  Duration: string;
  'End time': Date;
  'Job ID': string;
  'Job name': string;
  'Job type': string;
  Owner: string;
  'Report Definition': string;
  'Start time': Date;
  Status: string;
  Filter?: string;
  'Watchdogs (1)'?: string;
  'Watchdogs (2)'?: string;
  'Watchdogs (3)'?: string;
  'Watchdogs (4)'?: string;
  'Watchdogs (5)'?: string;
}

export interface ParsedReportParams {
  info: Info | undefined;
  params: {
    [key: string]: any;
  };
  uuid: string;
}

interface JobResult {
  info: string;
  params: string;
  uuid: string;
}

export type ExportOutputFormat =
  | 'OF_PDF'
  | 'OF_ESRI_SHAPES'
  | 'OF_CSV'
  | 'OF_EXCEL'
  | 'OF_ZIP'
  | 'OF_ESRI_RASTER'
  | 'OF_SHIPLIST'
  | 'OF_CSV_TRACK';

export const getReportTemplates = async (
  session: Session
): Promise<ReportTemplate[] | null> => {
  const response: JobTemplateResult = await session.request('getJobList', {
    showSharedJobs: true,
    forceRefresh: true,
  });

  response;

  return response.records;
};

const parseResponse = (response: JobResult): ParsedReportParams => {
  let parsedInfo = undefined;
  let parsedParams = {};

  try {
    // Only parse if the string is not empty
    if (response.info) {
      parsedInfo = JSON.parse(response.info);
    }
    if (response.params) {
      parsedParams = JSON.parse(response.params);
    }
  } catch (error) {
    console.error('Error parsing JSON: ', error);
  }

  return {
    info: parsedInfo,
    params: parsedParams,
    uuid: response.uuid,
  };
};
export const getReport = async (
  session: Session,
  jobId: string
): Promise<ParsedReportParams> => {
  const response: JobResult = await session.request('getJobParams', {
    jobUuid: jobId,
  });

  return parseResponse(response);
};

export const getReportExportFormats = async (
  session: Session,
  type: string
): Promise<ExportOutputFormat[]> => {
  const response = await session.request('getExportFormats', {
    type: type,
  });

  // session.request already unwraps the JSON-RPC response and returns the result directly
  return response as ExportOutputFormat[] || [];
};
